import TagList from '../components/tagList'
import { alphabeticalFilter } from '../modules'

export default class Modal {
	constructor(el) {
		this.$modal = $('#modal');
		this.$body = this.$modal.find('.modal-body');
		this.$header = $('#header_wrapper');

		this.$el = $(el);
		this.$close = this.$el.find('.close');
		this.$target = $(this.$el.data('modal')).clone();

		this.$el.on('click', this.open.bind(this));
		this.$close.on('click', this.hide.bind(this));
		$(document).on('click', this.outside.bind(this));
	}

	open(e) {
		e.stopPropagation();

		if (this.$target.length === 0) {
			return;
		}

		if (this.$target.hasClass('categories_list')) {
			var tagList = new TagList(this.$target);
			tagList.init();

			this.$target.find('.alphabetical-filter').each(alphabeticalFilter)
		}

		this.$body.prepend(this.$target)
		this.$modal.removeClass('hidden')
		this.$header.hide()
	}

	hide() {
		this.$header.show();
		this.$modal.addClass('hidden');
		this.$body.empty();
	}

	outside(e) {
		if(!$(e.target).closest('.modal-body').length && !$(e.target).is('.modal-body')) {
			if(this.$modal.is(":visible")) {
				this.hide();
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/desktop/scripts/ui/modal.js